import React, { useEffect, useState } from "react";
import { BASE_DEV_URL } from "../../../config/api.config";

const TopBannerSlider = ({ inPlaySlidingBanners }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(
        (prevIndex) => (prevIndex + 1) % inPlaySlidingBanners.length
      );
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, [inPlaySlidingBanners.length]);

  return (
    <div
      id="banners"
      className=" w-full px-[6px] rounded-md overflow-hidden"
      style={{ aspectRatio: 2.00561 / 1, maxHeight: "350px" }}
    >
      <div className="w-full relative h-full z-10 rounded-md overflow-hidden">
        {inPlaySlidingBanners.map((item, index) => {
          let image_url = `${BASE_DEV_URL}${item.description}`;

          if (item.hasOwnProperty("self_host")) {
            if (item.self_host == true) {
              image_url = `${BASE_DEV_URL}${item.description}`;
            } else {
              image_url = item.description;
            }
          } else {
            image_url = `${BASE_DEV_URL}${item.description}`;
          }

          return (
            <img
              key={`_${index}`}
              src={image_url}
              className={`min-w-full min-h-full absolute top-0 left-0 transition-transform duration-500 ease-in-out ${
                index === currentIndex
                  ? "translate-x-0"
                  : index < currentIndex
                  ? "-translate-x-full"
                  : "translate-x-full"
              }`}
              alt={`Carousel Image ${index}`}
              loading="lazy"
            />
          );
        })}
      </div>
    </div>
  );
};

export default TopBannerSlider;
